import styles from "./Header.module.scss";
import { useState } from "react";
import Text from "../Typography/Text/Text";
import Heading from "../Typography/Heading/Heading";
import telegram from "../../static/images/telegram_black.svg";
import youtube from "../../static/images/youtube_black.svg";
import vk from "../../static/images/vk_black.svg";
import odnoklassniki from "../../static/images/odnoklassniki_black.svg";

export default function Header() {
  const [headerActive, setHeaderActive] = useState(true);
  const [headerBackgroungActive, setHeaderBackgroundActive] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [mobileMenuActive, setMobileMenuActive] = useState(false);

  window.addEventListener("scroll", () => {
    const scrollDistance = window.scrollY;

    if (mobileMenuActive === false) {
      if (scrollDistance > scrollPosition) {
        setHeaderActive(false);
        setHeaderBackgroundActive(false);
      } else if (scrollDistance < scrollPosition) {
        setHeaderActive(true);
        setHeaderBackgroundActive(true);
      }

      if (scrollDistance < 110) {
        setHeaderBackgroundActive(false);
      }

      setScrollPosition(scrollDistance);
    }
  });

  function headerHide() {
    setTimeout(() => {
      setHeaderActive(false);
      setHeaderBackgroundActive(false);
    }, 1000);
  }

  return (
    <div
      className={
        headerActive ? `${styles.wrap} ${styles.active}` : `${styles.wrap}`
      }
    >
      <div
        className={
          headerBackgroungActive
            ? `${styles.background} ${styles.active}`
            : `${styles.background}`
        }
      />
      <div className={`${styles.container} container`}>
        <div className={styles.header}>
          <div className={styles.mainIcons}>
            <div
              className={
                headerBackgroungActive
                  ? `${styles.mainIcons__logo} ${styles.black}`
                  : `${styles.mainIcons__logo}`
              }
            >
              <a href="https://ch-sk.ru/"></a>
            </div>
            <div
              onClick={() => {
                setMobileMenuActive(!mobileMenuActive);
              }}
              className={
                headerBackgroungActive
                  ? `${styles.mainIcons__menu} ${styles.black}`
                  : `${styles.mainIcons__menu}`
              }
            ></div>
          </div>
          <div
            className={
              headerBackgroungActive
                ? `${styles.content} ${styles.black}`
                : `${styles.content}`
            }
          >
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="https://ch-sk.ru/" onClick={() => headerHide()}>
                  Вернуться на сайт
                </a>
              </Text>
            </div>
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#Advantages" onClick={() => headerHide()}>
                  Преимущества
                </a>
              </Text>
            </div>
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#ChargingMethods" onClick={() => headerHide()}>
                  Способы зарядки
                </a>
              </Text>
            </div>
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#Specifications" onClick={() => headerHide()}>
                  Технические характеристики
                </a>
              </Text>
            </div>
            {/* <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#News" onClick={() => headerHide()}>
                  Новости
                </a>
              </Text>
            </div> */}
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#Contacts" onClick={() => headerHide()}>
                  Контакты
                </a>
              </Text>
            </div>
            <div className={styles.content__item}>
              <Text size="base" fw={500}>
                <a href="#MobileApp" onClick={() => headerHide()}>
                  Мобильное приложение
                </a>
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          mobileMenuActive
            ? `${styles.mobileMenu} ${styles.active}`
            : `${styles.mobileMenu}`
        }
      >
        <div className={styles.mobileMenu__mainIcons}>
          <div className={styles.mobileMenu__mainIcons__logo}>
            <a href="https://ch-sk.ru/"></a>
          </div>
          <div
            onClick={() => {
              setMobileMenuActive(!mobileMenuActive);
            }}
            className={styles.mobileMenu__mainIcons__menu}
          ></div>
        </div>
        <div className={styles.mobileMenu__content}>
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a href="https://ch-sk.ru/">Вернуться на сайт</a>
            </Heading>
          </div>
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#Advantages"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Преимущества
              </a>
            </Heading>
          </div>
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#ChargingMethods"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Способы зарядки
              </a>
            </Heading>
          </div>
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#Specifications"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Технические характеристики
              </a>
            </Heading>
          </div>
          {/* <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#News"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Новости
              </a>
            </Heading>
          </div> */}
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#Contacts"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Контакты
              </a>
            </Heading>
          </div>
          <div className={styles.mobileMenu__content__item}>
            <Heading level="h5" fw={500}>
              <a
                href="#MobileApp"
                onClick={() => {
                  setMobileMenuActive(false);
                  headerHide();
                }}
              >
                Мобильное приложение
              </a>
            </Heading>
          </div>
        </div>

        <div className={styles.mobileMenu__footer}>
          <div className={styles.mobileMenu__footer__icons}>
            <div className={styles.icon}>
              <a href="https://t.me/chuvesk">
                <img src={telegram} alt="" />
              </a>
            </div>

            <div className={styles.icon}>
              <a href="https://www.youtube.com/channel/UC6VgyfcAknZ0pTYcjciMBeQ">
                <img src={youtube} alt="" />
              </a>
            </div>
            <div className={styles.icon}>
              <a href="https://vk.com/ch_esk">
                <img src={vk} alt="" />
              </a>
            </div>
            <div className={styles.icon}>
              <a href="https://ok.ru/group/52115161022617">
                <img src={odnoklassniki} alt="" />
              </a>
            </div>
          </div>
          <div className={styles.mobileMenu__footer__hotline}>
            <a href="tel:+78002000742">
              <div className={styles.mobileMenu__footer__hotline__item}>
                <Text size="small">Горячая линия</Text>
              </div>
              <div className={styles.mobileMenu__footer__hotline__item}>
                <Text size="small">8-800-2000-742</Text>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
